


































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { BankAccount, MangoPayMandate } from '@/store/mangoPay/types';
import { extendedDate } from '@/filters/date';
import { countryCodesArray } from '@/enum/CountryCodesEnum';
import { MandateStatus } from '@/enum/mangoPay/MandateTypes';
import MandateOverview from '@/components/bankAccount/shared/MandateOverview.vue';
import ExporoSelect from '@/components/_common/Select.vue';

@Component({
  name: 'bank-account-details',
  filters: {
    extendedDate,
  },
  components: {
    MandateOverview,
    ExporoSelect,
  },
})
export default class BankAccountDetails extends Vue {
  @Prop({ required: true }) bankAccount!: BankAccount;
  @Prop({ required: true }) mandate?: MangoPayMandate;
  @Prop({ default: true }) formDisabled?: Boolean;

  private currentTab = this.hasActiveMandate ? 'info' : 'mandates';
  private isMobile: Boolean = window.innerWidth < 768;

  private mounted(){
    if(!this.bankAccount){
      this.$router.push('/bank-account');
    }
  }


  get exporoSelectTabs() {
    return [
      { name: this.$t('bankAccount.title'), value: 'info' },
      { name: this.$t('mandates.title'), value: 'mandates' },
      { name: this.$t('forms.legend', { context: 'ownerDetails' }), value: 'owner' },
    ];
  }

  get hasActiveMandate() {
    return this.mandate?.Status === MandateStatus.ACTIVE ||
      this.mandate?.Status === MandateStatus.SUBMITTED;
  }

  get hasFailedMandate() {
    return this.mandate?.Status === MandateStatus.FAILED;
  }

  get hasActiveAccount() {
    return this.bankAccount.Active;
  }

  get mandateIcon() {
    return this.hasActiveMandate ? 'assignment'
      : this.hasFailedMandate ? 'report_problem'
        : 'schedule';
  }

  get mandateTitle() {
    return this.hasActiveMandate ? 'Active mandate'
      : this.hasFailedMandate ? 'Failed mandate'
        : 'Submitted mandate';
  }

  get tabName() {
    let tabName = '';
    switch (this.currentTab) {
      case 'info':
        tabName = this.$t('bankAccount.title', { context: 'details' });
        break;
      case 'mandates':
        tabName = this.$t('mandates.title');
        break;
      case 'owner':
        tabName = this.$t('forms.legend', { context: 'ownerDetails' });
        break;
    }

    return tabName;
  }

  getCountry(countryCode: string) {
    const country = countryCodesArray.find(
      country => country.isoAlpha2 === countryCode,
    );

    return country?.name || countryCode;
  }
}
